import { AC3BaseError } from './AC3BaseError';
export class AccessDeniedError extends AC3BaseError {
    constructor(message, cause, errorCodeContextInputs, displayContext) {
        super(message, cause, errorCodeContextInputs, displayContext);
        this.name = 'AccessDeniedError';
    }
}
//# sourceMappingURL=AccessDeniedError.js.map